const charset = "utf-8";

module.exports = charset;
